import { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isNil } from 'lodash';
// Import Components
import CJPartnerBonusIdInfoBlock from './CJPartnerBonusIdInfoBlock';
import { CJBonusExpirationInfo, CJInfoBlockLabelValueWrapper } from 'components/CustomerJourney/infoBlocks';
// Import Constants
import { l } from 'constants/common';

const CJBonusInfoBlock = ({ data, customAttributes }) => {
    const { t } = useTranslation();

    return (
        <div>
            <CJPartnerBonusIdInfoBlock data={{ value: data.bonusId }} customAttributes={customAttributes} />
            {!isNil(data.expiration) && <CJBonusExpirationInfo expiration={data.expiration} />}
            {data.wallet && <CJInfoBlockLabelValueWrapper label={t(l.Wallet)} value={data.wallet} />}
            {data.amounts.map(({ CurrencyCode, OriginalValue }, i) => (
                <CJInfoBlockLabelValueWrapper
                    key={i}
                    label={`${t(l.Amount)} ${CurrencyCode}`}
                    value={OriginalValue}
                    isLoading={false}
                />
            ))}
        </div>
    );
};

CJBonusInfoBlock.propTypes = {
    data: PropTypes.object.isRequired,
    customAttributes: PropTypes.object.isRequired,
};

export default memo(CJBonusInfoBlock);
